import { Navigate, useLocation, useParams } from 'react-router';

const ProgressLogsRedirect = () => {
  const { projectId } = useParams<{ projectId: string }>();
  const { search } = useLocation();

  return <Navigate to={`/projects/${projectId}/logs/progress${search}`} replace />;
};

export default ProgressLogsRedirect;
